import { render, staticRenderFns } from "./Investigations.vue?vue&type=template&id=4e1d7dfd&scoped=true"
import script from "./Investigations.vue?vue&type=script&lang=js"
export * from "./Investigations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d7dfd",
  null
  
)

export default component.exports